<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <router-view />
  </div>
</template>

<script>
import mailer from "./services/mailer.service";
export default {
  name: "app",
  mounted(){    
    // mailer.send({
    //         "to": "abdullah@venturexlabs.pk",
    //         "from": "noreply@primecab.com",
    //         "subject": "'Design Your Model S | Tesla'",
    //         "html": "<h1>Have the most fun you can in a car!</h1><p>Get your <b>Tesla</b> today!</p>",
    //         "attachments": [
    //           {
    //             "filename": "your-testla.png",
    //             "path": "https://media.gettyimages.com/photos/view-of-tesla-model-s-in-barcelona-spain-on-september-10-2018-picture-id1032050330?s=2048x2048"
    //           }
    //         ]
    //       })
  }
};
</script>

<style>
</style>
